<template>
  <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.20711 0C0.761654 0 0.538571 0.538571 0.853553 0.853553L3.39645 3.39645C3.59171 3.59171 3.90829 3.59171 4.10355 3.39645L6.64645 0.853554C6.96143 0.538571 6.73835 0 6.29289 0H1.20711Z"
      fill="#030134" />
  </svg>

</template>

<script>
export default {
  name: "IconDropdown"
};
</script>

<style>

</style>
